
(function (XHR) {
  "use strict";

  var open = XHR.prototype.open;
  var send = XHR.prototype.send;

  XHR.prototype.open = function (method, url, async, user, pass) {
    this._url = url;
    open.call(this, method, url, async, user, pass);
  };

  XHR.prototype.send = function (data) {
    var self = this;
    var url = this._url;

    if (url && url.toLowerCase() === "https://d7v7btdcw8f7hg8wvt1pljx1-fast.searchtap.net/v2".toLowerCase()) {
        const body = JSON.parse(data);
        body.facetCount = 1000;
        const url = new URL(location.href);
  
        const params = new URLSearchParams(url.search);
        const systemVendor = params.get("system_vendor");
        if (systemVendor) {
             body.textFacetFilters["system_vendor"] = [systemVendor];
        } else {
            console.log("delte object")
            delete body.textFacetFilters.system_vendor;
        }

     
      data = JSON.stringify(body);
    }
    send.call(this, data);
  }
})(XMLHttpRequest);

function toggleFilter() {
  let x = document.querySelector(".sq-filter-main");
  x.classList.toggle("opening");
}
function toggleClass() {
  let y = document.querySelector(".sq-filter-main");
  y.classList.remove("opening");
}
function removeClass() {
  let z = document.querySelector(".sq-filter-main");
  z.classList.remove("opening");
}

window.sq = window.sq || {};
window.FloatingUIDOM = window.FloatingUIDOM || {};
window.FloatingUIDOM.setupDropdown = (function () {
  const dropdownInput = document.querySelector("[name='q']");
  const dropdownList = document.getElementById("dropdownList");
  console.log("Hi",dropdownInput);

  const toggleDropdown = function () {

    if(!dropdownList) return;
    
    if (dropdownList?.style.display === "flex") {
      // dropdownList.style.display = "none";
    } else {
      dropdownList.style.display = "flex";
    }
  };

  const selectOption = function (option) {
    const selectedOption = option.textContent;
    dropdownInput.value = selectedOption;
    toggleDropdown();
  };

  // Show dropdown list on input box click
  dropdownInput.addEventListener("focus", toggleDropdown);
  return {
    selectOption: selectOption,
  };
})();
window.addEventListener("click", function (event) {
  const dropdownInput = document.querySelector("[name='q']");
  const dropdownList = document.getElementById("dropdownList");
  if ((!dropdownList.contains(event.target) && event.target !== dropdownInput && document.querySelector(".closeSearch").contains(event.target)) || document.querySelector(".modalOverly").contains(event.target)) {
    dropdownList.style.display = 'none'; // Hide the dropdown list
  }
  
  if (dropdownInput.contains(event.target)) {
    dropdownList.style.display = 'block'; // Show the dropdown list
  }
});
window.sq.dropdownSearch = (store) => {
  store.search({ page: 1, restrictByCollection: false });
};



window.sq.changeView = () => {
  const gridButton = document.querySelector('[data-layout-mode="grid"]');
  const listButton = document.querySelector('[data-layout-mode="list"]');
  const productList = document.querySelector(".collection__products");
  const dataGrid = document.querySelector(".sq-results");

  gridButton.addEventListener("click", () => {
    productList?.classList.remove("list-view");
    dataGrid.style.display = "flex";
    gridButton?.classList.add("active");
    dataGrid?.classList.remove("sq-list-view");
    listButton?.classList.remove("active");
    window.sq.custom = { isList: false };
  });

  listButton.addEventListener("click", () => {
    productList?.classList.add("list-view");
    dataGrid?.classList.add("sq-list-view");
    gridButton?.classList.remove("active");
    listButton?.classList.add("active");
    window.sq.custom = { isList: true };
  });
};

window.addEventListener("load", () => {
  
  if (window.matchMedia("(max-width: 767px)").matches) {
    document
      .getElementById("Search-In-Modal")
      .addEventListener("focusin", () => {
        document.querySelector(".sq-dropdown-body").style.maxHeight = "100%";
      });
    document
      .getElementById("Search-In-Modal")
      .addEventListener("focusout", () => {
        document.querySelector(".sq-dropdown-body").style.maxHeight = "0px";
      });
  }
});



setTimeout(()=>{
  if(document.querySelector(".sq-filter-main")) document.querySelector(".sq-filter-main").style.visibility=null;
  if(document.querySelector(".sparq-container")) document.querySelector(".sparq-container").style.visibility=null;
},200);



function addVat(num){
  return num*120/100;
}
window.sq.addVat = (product)=>{
  product.originalPrice = product.price;
  product.price = addVat(product.price);
  product.compare_at_price = addVat(product.compare_at_price);
  // console.log(product);
  return product;
}
document.querySelector("[name='q']").addEventListener("keydown",(e)=>{
    if(e.key=="Enter"){
      e.preventDefault();
      location.href=location.origin+"/search?q="+e.target.value;
    }
})

window.sq.onData = async (item,isDropdown) => {
  let sparqCard
 setTimeout(()=>{
    if(isDropdown){
    sparqCard = document.querySelector(`.search-result[product-handle="${item.handle}"]`);
   
  }else{
    sparqCard = document.querySelector(`.sparq-card[product-handle="${item.handle}"]`);
  }
 
    if(item.productId !== "7230569644090") return true;
      console.log(item)
     fetch("/products/" + item.handle + ".json")
      .then((res) => res.json())
      .then((d) => {
        const price = sparqCard.querySelector(".sq-sy-price .sq-price");
        const compare_at_price = sparqCard.querySelector(".sq-sy-price .sq-compare-price");
        const originalPrice = sparqCard.querySelector(".sq-originalPrice")
        if(price) price.innerHTML = "£"+((d.product.variants[21].price)*1.2).toFixed(2);
        if(compare_at_price) compare_at_price.innerHTML= "£"+((d.product.variants[21].compare_at_price)*1.2).toFixed(2);
        if(originalPrice) originalPrice.innerHTML = "Ex. Tax: £"+(d.product.variants[21].price);
      })
 });
    
  return true;
}; 

